export const or = {
    "TRIGGER_LISTEN": "ଟ୍ରିଗରଗୁଡ଼ିକ ପାଇଁ ସୁଣୁଛି,",
    "ASSIST_EMPTY_MSG": "ଏଜେଣ୍ଟ AI ଆପଣଙ୍କର ସଂଭାଷଣକୁ ସକ୍ରିୟ ଭାବେ ସୁଣୁଛି ଏବଂ ଟ୍ରିଗର ହେଲେ ସ୍ୱୟଂଚାଳିତ ଭାବେ ସାହାଯ୍ୟ କରିବାକୁ ପ୍ରସ୍ତୁତ ଅଛି।,",
    "MYBOT_TRIGGET_LISTEN": "ବର୍ତ୍ତମାନ କୌଣସି ସକ୍ରିୟ ମୋର ବୋଟ୍ କାର୍ଯ୍ୟ ନାହିଁ।,",
    "MYBOT_EMTPY_MSG": "ମୋର ବୋଟ୍ ଉପରେ କାର୍ଯ୍ୟ ଆରମ୍ଭ କରିବା ପାଇଁ, ସର୍ଚ୍ଚ ଟାବ୍କୁ ଯାଆନ୍ତୁ ଏବଂ ଆପଣଙ୍କର ଆବଶ୍ୟକ କାର୍ଯ୍ୟ ପାଇଁ \"\"ଏଜେଣ୍ଟ ଇନପୁଟ୍ ସହିତ ଚାଲନ୍ତୁ\"\" ବିକଳ୍ପ ଚୟନ କର ନ୍ତୁ।,",
    "PROACTIVE_MODE": "ପ୍ରୋଆକ୍ଟିଭ୍ ମୋଡ୍,",
    "SETTINGS": "ସେଟିଂଗ୍ସ,",
    "HELP_AND_SUPPORT": "ସାହାଯ୍ୟ ଏବଂ ସମର୍ଥନ,",
    "HELP": "ସାହାଯ୍ୟ,",
    "LANGUAGE": "ଭାଷା,",
    "THEME": "ଥିମ୍,",
    "AUTOMATIC": "ସ୍ୱୟଂଚାଳିତ,",
    "DARK": "ଅନ୍ଧାର,",
    "LIGHT": "ଆଲୋକ,",
    "THEME_DESC": "ଏହା ଆପଣଙ୍କର ସିଷ୍ଟମ୍ ଡିଫଲ୍ଟ ମୋଡ୍ ବ୍ୟବହାର କରିବ।,",
    "DOCUMENTATION": "ଡକ୍ୟୁମେଣ୍ଟେସନ୍,",
    "DOC_DESC": "ଆମର ଭିତରୁ ଥିବା ଡକ୍ୟୁମେଣ୍ଟେସନ୍ ଲେଖଗୁଡ଼ିକ ଯାଞ୍ଚ କରନ୍ତୁ।,",
    "FAQ_U": "ସାଧାରଣତଃ ପ୍ରଶ୍ନ,",
    "FAQ_DESC": "ଏଜେଣ୍ଟ AI ବିଷୟରେ ସାଧାରଣତଃ ପ୍ରଶ୍ନଗୁଡ଼ିକ ଯାଞ୍ଚ କରନ୍ତୁ।,",
    "KORE_ACADEMY": "କୋର ଅକାଦେମୀ,",
    "KORE_ACA_DESC": "ଅକାଦେମୀ କୋର୍ସଗୁଡ଼ିକ ଯାଇ ଏଜେଣ୍ଟ AI ବିଷୟରେ ଅଧିକ ଜାଣନ୍ତୁ।,",
    "SEARCH": "ସନ୍ଧାନ,",
    "MY_BOT": "ମୋର ବୋଟ୍,",
    "ASSIST": "ସାହାଯ୍ୟ,",
    "TRANSCRIPT": "ଟ୍ରାନ୍ସକ୍ରିପ୍ଟ,",
    "HISTORY": "ଇତିହାସ,",
    "STARTOVER": "ପୁଣି ଆରମ୍ଭ କରନ୍ତୁ,",
    "RESTART_INPUTS": "ଧରା ପଡ଼ିଥିବା ଇନପୁଟ୍ ସହିତ ପୁଣି ଆରମ୍ଭ କରନ୍ତୁ,",
    "ASKCUSTOMER": "ଗ୍ରାହକକୁ ପଚାରନ୍ତୁ,",
    "TELLCUSTOMER": "ଗ୍ରାହକକୁ କହନ୍ତୁ,",
    "WELCOME_MSG": "ସ୍ୱାଗତ ସନ୍ଦେଶ,",
    "SEND": "ପଠାନ୍ତୁ,",
    "SENT": "ପଠାଯାଇଛି,",
    "AWAITING": "ପ୍ରତିକ୍ରିୟା ଆସିବା ପାଇଁ ଅପେକ୍ଷା କରୁଛି | ଜାରି ରଖିବା ପାଇଁ ଟାଇପ୍ କରନ୍ତୁ,",
    "OVERRIDE": "ଜାରି ରଖିବା ପାଇଁ ଟାଇପ୍ କରନ୍ତୁ,",
    "OVERRIDE_FILE": "ଜାରି ରଖିବା ପାଇଁ ଫାଇଲ୍ ସଂଯୁକ୍ତ କରନ୍ତୁ,",
    "ACCEPT_RESPONSE": "ପ୍ରତିକ୍ରିୟା ଗ୍ରହଣ କରାଯାଇଛି,",
    "AGENT_ENTERED": "ଏଜେଣ୍ଟ ପ୍ରବେଶ କରିଛି,",
    "EXPECTED_FORMAT": "ଆଶା କରାଯାଇଥିବା ଫର୍ମାଟ୍,",
    "INPUT_VALUES": "ଇନପୁଟ୍ ମୂଲ୍ୟ,",
    "RESTART": "ପୁଣି ଆରମ୍ଭ କରନ୍ତୁ,",
    "START_OVER": "ପୁଣି ଆରମ୍ଭ କରନ୍ତୁ,",
    "RESTART_CAPTURE": "ଧରା ପଡ଼ିଥିବା ଇନପୁଟ୍ ସହିତ ପୁଣି ଆରମ୍ଭ କରନ୍ତୁ,",
    "CANCEL": "ରଦ୍ଦ କରନ୍ତୁ,",
    "INTERRUPT_DIALOG": "ବିଛିନ୍ନ ଡାଏଲଗ୍ କାର୍ଯ୍ୟ,",
    "RUN": "ଚାଲନ୍ତୁ,",
    "RUN_AGENT": "ଏଜେଣ୍ଟଙ୍କର ଇନପୁଟ୍ ସହିତ ଚାଲନ୍ତୁ,",
    "STEP": "ପଦକ୍ଷେପ,",
    "DIALOG_TASK": "ଡାଏଲଗ୍ କାର୍ଯ୍ୟ,",
    "FAQ": "ସାଧାରଣତଃ ପ୍ରଶ୍ନ,",
    "SNIPPET": "ଉତ୍ତରଗୁଡ଼ିକ,",
    "ARTICLE": "ୱେବ୍ ପୃଷ୍ଠାଗୁଡ଼ିକ,",
    "FILE": "ଫାଇଲ୍,",
    "SUGGESTED": "ସୁପାରିସ୍,",
    "ALL_DIALOG": "ସମସ୍ତ ଡାଏଲଗ୍ କାର୍ଯ୍ୟ,",
    "DIALOG_TEXT": "ସଂଭାଷଣ,",
    "INTENT_IDENTIFIED": "ଗ୍ରାହକ କହିବା,",
    "NOT_WHAT_LOOKING": "ଭୁଲ୍ ସୁପାରିସ୍?",
    "BOT": "ବୋଟ୍,",
    "CUSTOMER": "ଗ୍ରାହକ,",
    "YOU": "ଆପଣ,",
    "TERMINATE_CONV": "ଡାଏଲଗ୍ କାର୍ଯ୍ୟ ସମାପ୍ତ କରନ୍ତୁ,",
    "TERMINATE_CONV_DESC": "ଆପଣ ନିଶ୍ଚିତ କି ଆପଣ ଡାଏଲଗ୍ କାର୍ଯ୍ୟ ସମାପ୍ତ କରିବାକୁ ଚାହାଁନ୍ତି? ଏଜେଣ୍ଟ AI ଆଉ ସୁପାରିସ୍ ଦେଇପାରିବ ନାହିଁ।,",
    "YES_TERMINATE": "ହଁ ସମାପ୍ତ କରନ୍ତୁ,",
    "NO_CANCEL": "ନା, ରଦ୍ଦ କରନ୍ତୁ,",
    "OVERRIDE_CONTINUE": "ଓଭରରାଇଡ୍ ମୋଡ୍ ସହିତ ଜାରି ରଖନ୍ତୁ,",
    "SUMMARY_TEXT": "ସାରାଂଶ,",
    "SUBMIT": "ଦାଖଲ କରନ୍ତୁ,",
    "INTERRUPT_OCCURED": "ବିଚ୍ଛିନ୍ନତା ଘଟିଛି,",
    "IDENTIFIED_INTENT": "ପରିଚିତ ଉଦ୍ଦେଶ୍ୟ,",
    "INTERRUPT_DESC": "ଏହାକୁ ଚାଲାଇବା ଆପଣଙ୍କର ଚାଲିଥିବା ଡାଏଲଗ୍ କାର୍ଯ୍ୟକୁ ସମାପ୍ତ କରିବ।,",
    "ACCEPT_RUN": "ଗ୍ରହଣ କରନ୍ତୁ ଏବଂ ଚାଲନ୍ତୁ,",
    "RUN_LATER": "ପରେ ଚାଲନ୍ତୁ,",
    "KNOW_MORE": "ଅଧିକ ଜାଣନ୍ତୁ,",
    "MORE_TEXT": "ଅଧିକ,",
    "LESS_TEXT": "କମ୍,",
    "VIEW_MORE": "ଅଧିକ ଦେଖନ୍ତୁ,",
    "VIEW_LESS": "କମ୍ ଦେଖନ୍ତୁ,",
    "SHOW_MORE_FAQ": "ଅଧିକ ସାଧାରଣତଃ ପ୍ରଶ୍ନ ଦେଖନ୍ତୁ,",
    "SHOW_LESS_FAQ": "କମ୍ ସାଧାରଣତଃ ପ୍ରଶ୍ନ ଦେଖନ୍ତୁ,",
    "SHOW_MORE_ARTICLE": "ଅଧିକ ୱେବ୍ ପୃଷ୍ଠାଗୁଡ଼ିକ ଦେଖନ୍ତୁ,",
    "SHOW_LESS_ARTICLE": "କମ୍ ୱେବ୍ ପୃଷ୍ଠାଗୁଡ଼ିକ ଦେଖନ୍ତୁ,",
    "SHOW_MORE_SNIPPET": "ଅଧିକ ଉତ୍ତରଗୁଡ଼ିକ ଦେଖନ୍ତୁ,",
    "SHOW_LESS_SNIPPET": "କମ୍ ଉତ୍ତରଗୁଡ଼ିକ ଦେଖନ୍ତୁ,",
    "SHOW_MORE_FILES": "ଅଧିକ ଫାଇଲ୍ ଦେଖନ୍ତୁ,",
    "SHOW_LESS_FILES": "କମ୍ ଫାଇଲ୍ ଦେଖନ୍ତୁ,",
    "VIEW_ALL_DIALOG": "ସମସ୍ତ ସଂଭାଷଣ ଦେଖନ୍ତୁ,",
    "VIEW_FEW_DIALOG": "କିଛି ସଂଭାଷଣ ଦେଖନ୍ତୁ,",
    "HELP_FULL": "ସାହାଯ୍ୟକାରୀ?",
    "THANKYOU": "ଧନ୍ୟବାଦ",
    "EXPAND_MORE": "ବିସ୍ତାର କରନ୍ତୁ / ଅଧିକ,",
    "CLOSE_TEXT": "ବନ୍ଦ କରନ୍ତୁ,",
    "STARTED": "ଆରମ୍ଭ ହେଲା,",
    "ENDED": "ସମାପ୍ତ ହେଲା,",
    "VIEW_FULL_ARTICLE": "ୱେବ୍ ପୃଷ୍ଠା ଦେଖନ୍ତୁ,",
    "VIEW_FULL_FILE": "ଫାଇଲ୍ ଦେଖନ୍ତୁ,",
    "COPIED": "କପି ହୋଇଛି,",
    "SENTI_ANALY": "ଭାବ ବିଶ୍ଳେଷଣ,",
    "WRONG_SUGGESTION": "ଭୁଲ୍ ସୁପାରିସ୍ଗୁଡ଼ିକ,",
    "INCORRECT_INTENT": "ଭୁଲ୍ ଉଦ୍ଦେଶ୍ୟ,",
    "ACCIDENTAL_CLICK": "ଭୁଲ୍ ଦବାଇ ଦିଆଯାଇଛି,",
    "TIME_TAKING": "ସମୟ ନିଅଯାଇଛି,",
    "OTHER": "ଅନ୍ୟ,",
    "PLAYBOOK_EMPTY_MSG": "ପ୍ଲେବୁକ୍ ବାଛନ୍ତୁ,",
    "PLAYBOOK_EMPTY_DESC": "ସମସ୍ତ ଉପଲବ୍ଧ ପ୍ଲେବୁକ୍ ଗୁଡ଼ିକ ଗତିଶୀଳ ହେବାରୁ ଏଜେଣ୍ଟ AI ପ୍ଲେବୁକ୍ ଲୋଡ୍ କରିପାରୁ ନାହିଁ। ପ୍ଲେବୁକ୍ ପ୍ରବେଶ କରିବାକୁ 'ପ୍ଲେବୁକ୍ ବାଛନ୍ତୁ' ଉପରେ କ୍ଲିକ୍ କରନ୍ତୁ,",
    "STAGE": "ଚରଣ,",
    "PROCEED_TO_CLOSE": "ବନ୍ଦ କରିବାକୁ ଅଗ୍ରସର ହୁଅନ୍ତୁ,",
    "RECOMENDED_PLAYBOOK": "ସୁପାରିସ୍ କରାଯାଇଥିବା ପ୍ଲେବୁକ୍,",
    "PRIMARY_SCRIPTS": "ପ୍ରାଥମିକ ସ୍କ୍ରିପ୍ଟଗୁଡ଼ିକ,",
    "DYNAMIC_SCRIPTS": "ଗତିଶୀଳ ସ୍କ୍ରିପ୍ଟଗୁଡ଼ିକ,",
    "RESUME": "ପୁଣି ଆରମ୍ଭ କରନ୍ତୁ,",
    "ENABLE_CLOSE": "ବନ୍ଦ କରିବା ପାଇଁ ଅଗ୍ରସର ହେବା ବଟନ୍ ଉପରେ କ୍ଲିକ୍ କରନ୍ତୁ,",
    "LIST_VIEW": "ସୂଚୀ ଦୃଶ୍ୟ,",
    "TERMINATE": "ସମାପ୍ତ କରନ୍ତୁ,",
    "MINIMIZE": "ନ୍ୟୁନତମ କରନ୍ତୁ,",
    "MAXIMIZE": "ଅଧିକତମ କରନ୍ତୁ,",
    "NO_SEARCH_RESULT": "କୌଣସି ସନ୍ଧାନ ଫଳାଫଳ ମିଳିଲା ନାହିଁ,",
    "SENTIMENT_AWAITING": "ଭାବ ପାଇଁ ଅପେକ୍ଷା କରୁଛି,",
    "AUTO_SCROLL_TOOLTIP":"ସହାୟତା ଟ୍ୟାବ୍, ମୋର ବୋଟ୍ ଏବଂ ଟ୍ରାନ୍ସକ୍ରିପ୍ଟ ଟ୍ୟାବ୍ ବିଷୟବସ୍ତୁର ସ୍ୱୟଂଚାଳିତ ସ୍ୱୟଂଚାଳିତ ସ୍କ୍ରୋଲ୍ ନିୟନ୍ତ୍ରଣ କରେ",
    "POSITIVE": "ସକାରାତ୍ମକ,",
    "NEGATIVE": "ନକାରାତ୍ମକ,",
    "FILE_NAME":"ଫାଇଲ୍ ନାମ",
    "ASSOCIATED_WORK_NOTES": "ପୂର୍ବ ସମାଧାନ ନୋଟଗୁଡ଼ିକ,",
    "AGENT_JOINED_CONV": "ଏଜେଣ୍ଟ ସଂଭାଷଣକୁ ଯୋଗ ଦେଲା,",
    "AUTOSCROLL_ASSIST": "ସ୍ୱୟଂ-ସ୍କ୍ରୋଲ୍ ସାହାଯ୍ୟ ଟାବ୍ ସାମଗ୍ରୀ,",
    "FILE_SIZE_MSG": "ଫାଇଲ୍ ଆକାର 25MB ମଧ୍ୟରେ ହେବା ଆବଶ୍ୟକ। କୃପୟା ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ।,",
    "OVERRIDE_BTN": "ଓଭରରାଇଡ୍,",
    "CHOOSE_FILE": "ଫାଇଲ୍ ବାଛନ୍ତୁ,",
    "SUMMARY_ERROR_TEXT": "ମାଫ କରନ୍ତୁ, କିନ୍ତୁ ଏହି ସଂଭାଷଣ ପାଇଁ ସାରାଂଶ ଉତ୍ପାଦନ କରିବାରେ ସମସ୍ୟା ହୋଇଛି। ଦୟାକରି ଆପଣଙ୍କ ସ୍ୱୟଂ ସାରାଂଶ ତିଆରି କରନ୍ତୁ,",
    "ASK_A_QUESTION": "ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ",
    "COPY" : "ନକଲ",
    "TELL_US_MORE": "ଅଧିକ କହନ୍ତୁ",
    "TAP_SEARCH":"ସନ୍ଧାନ ପାଇଁ ଟ୍ୟାପ୍ କରନ୍ତୁ",
    "TAB_TEXT": "କୌଣସି ଟ୍ୟାବ୍ ସକ୍ରିୟ ହୋଇନାହିଁ! କୃପାୟା କମରେ ଏକ ଟ୍ୟାବ୍ ସକ୍ରିୟ କରନ୍ତୁ",
    "THANKS_FEEDBACK": "ଆପଣଙ୍କର ପ୍ରତିକ୍ରିୟା ପାଇଁ ଧନ୍ୟବାଦ",
    "PLAYBOOK": "ପ୍ଲେବୁକ୍",
    "SOMETHING_WRONG": "କିଛି ତ୍ରୁଟି ଘଟିଗଲା",
    "CLICK_ERROR_DETAILS": "ତ୍ରୁଟି ବିବରଣୀ ଦେଖିବାକୁ କ୍ଲିକ୍ କରନ୍ତୁ",
    "NO_ACTIVE_PLAYBOOK": "କୋଣସି ସକ୍ରିୟ ପ୍ଲେବୁକ୍ ନାହିଁ",
    "REPHRASE_QUESTION": "ଆପଣଙ୍କର ପ୍ରଶ୍ନ ପୁନର୍ବ୍ୟବହାର କରିବାକୁ କିମ୍ବା ଅନ୍ୟ କିଛି ପଚାରିବାକୁ ସକ୍ଷମ କି?",
    "INTERNAL_INFO": "ଆନ୍ତରିକ ତଥ୍ୟ",
    "SOURCES": "ସ୍ରୋତ",
    "CONVERSATION_SUMMARY": "ଗପ ଗୋସ୍ତିର ସାରାଂଶ",
    "WAITING": "ପ୍ରତୀକ୍ଷା କରୁଛି",
    "WIDGET_DISABLED": "ଉଇଜେଟ୍ ବନ୍ଦ ହୋଇଛି",
    "AI_SETTINGS_DISABLED": "AI ସେଟିଂସ୍ ବନ୍ଦ ହୋଇଛି! AI ପ୍ରବନ୍ଧକଙ୍କୁ ସମ୍ପର୍କ କରନ୍ତୁ",
    "SERVER_CONNECTION_ERROR": "ସର୍ଭର ସହିତ ଯୋଗାଯୋଗ କରିବା ସମୟରେ ତ୍ରୁଟି",
    "VIEW": "ଦେଖନ୍ତୁ",
    "ATTACHMENT_INPUT": "ଅଂଶ ଇନ୍ପୁଟ",
    "TYPE_SUMMARY": "ସାରାଂଶ ଟାଇପ୍ କରନ୍ତୁ",
    "VIEW_FULL_ARTICLE_2": "ପୂର୍ଣ୍ଣ ଲେଖା ଦେଖନ୍ତୁ",
    "VIEW_FULL_FILE_2": "ପୂର୍ଣ୍ଣ ଫାଇଲ୍ ଦେଖନ୍ତୁ",
    "BY":"ମାଧ୍ୟମରେ",
    GENERATE_SUMMARY: "ସାରାଂଶ ଉତ୍ପନ୍ନ କରନ୍ତୁ",
    PREV_SUMMARIES: "ପୂର୍ବରୁ ସୃଷ୍ଟି ହୋଇଥିବା ସାରାଂଶ",
    DIALOG_WORKFLOWS: "ଡାଇଲଗ୍ ୱାର୍କଫ୍ଲୋ",
    SHOW_ALL_DIALOG: "ସମସ୍ତ ଡାଇଲଗ୍ ଟାସ୍କ ଦେଖାନ୍ତୁ",
    SHOW_ALL_DIALOGS: "ସମସ୍ତ ଡାଇଲଗ୍ ଦେଖାନ୍ତୁ",
    CUSTOM_TAB: "କଷ୍ଟମ୍ ଟ୍ୟାବ୍",
    AGENT_INPUT: "ଏଜେଣ୍ଟ ଇନ୍ପୁଟ",
    "CUSTOM_EMPTY_MSG" : "କୋଣସି ସକ୍ରିୟ ପ୍ଲେବୁକ୍ ନାହିଁ",
    "CUSTOM_TAB_DESC" : "ଏକ ପ୍ଲେବୁକ୍ ଆରମ୍ଭ କରିବାକୁ, ସ୍କ୍ରିନର ନିଚରେ ଉପଲବ୍ଧ ତାଲିକାରୁ ଏକ ଚୟନ କରନ୍ତୁ।",
    "SUBMIT_OVERALL_FEEDBACK" : "ସମସ୍ତ ପ୍ରତିକ୍ରିୟା ଜାରି କରନ୍ତୁ",
    "FEEDBACK_POPUP_SUBTITLE" : "ଉଇଜେଟ୍ ଆରେ ଏହାର ସୁବିଧାଗୁଡ଼ିକ ବିଷୟରେ ଆପଣଙ୍କର ଅଭିଗମ୍ଯତା",
    "FEEDBACK_SATISFIED" : "ସନ୍ତୁଷ୍ଟ",
    "FEEDBACK_UNSATISFIED" : "ସନ୍ତୁଷ୍ଟ ନାହିଁ",
    "FEEDBACK_PROVIDE_REASONS" : "ଅଧିକ ତଥ୍ୟ ଦିଅନ୍ତୁ…",
    "FEEDBACK_TITLE" : "ପ୍ରତିକ୍ରିୟା",
    "AGENTIC_THINKING" : "ଚିନ୍ତା କରୁଛି",
    "AGENTIC_AGENT_TITLE" : "ଏଜେଣ୍ଟ",
    "AGENTIC_COPILOT_MODE_TITLE" : "ଏଜେଣ୍ଟିକ୍ କୋପିଲଟ୍ ମୋଡ୍",
    "AGENTIC_SENDING_MESSAGE" : "ପଠାଉଛି...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot ଆପଣଙ୍କର ବାର୍ତ୍ତାଳାପକୁ ସକ୍ରିୟ ଭାବରେ ଶୁଣୁଛି ଏବଂ ସ୍ୱୟଂଚାଳିତ ଭାବରେ ସହାୟତା କରିବାକୁ ପ୍ରସ୍ତୁତ |",
    "AGENTIC_SEARCH_RESULTS" : "ଏଜେଣ୍ଟ ଫଳାଫଳ",
    "PAUSE_AUTO_SEND" : "ସ୍ୱୟଂଚାଳିତ ପଠାଇବା ବନ୍ଦ କରନ୍ତୁ",
    "PAUSE_AGENTIC" : "ଏଜେଣ୍ଟ ବନ୍ଦ କରନ୍ତୁ",
    "RESUME_AGENTIC" : "ଏଜେଣ୍ଟ ପୁନର୍ବାର ଆରମ୍ଭ କରନ୍ତୁ",
    "RESUME_AUTO_SEND" : "ସ୍ୱୟଂଚାଳିତ ପଠାଇବା ପୁନର୍ବାର ଆରମ୍ଭ କରନ୍ତୁ"
}